import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../utils/images";

const SignIn_Page_1 = () => {
  return (
    <div className="outlet-render">
      <div className="signin-main-container">
        <div className="signin-left-container">
          <h1 className="signin-heading">Welcome Back</h1>
          <label className="signup-label">Email </label>
          <input
            className="signup-input"
            type="email"
            placeholder="name@email.com"
          />
          <label className="signup-label">Enter Password</label>
          <input
            className="signup-input"
            type="password"
            placeholder="Password"
          />
          <h2>Forgot Password?</h2>

          <Link to="/dashboard" className="link">
            <button className="signup-button">Login</button>
          </Link>

          <p className="privacy">
            By signing up, you agree to our Terms of Use and Privacy Policy.
          </p>

          <h2 className="signup-login-button">
            Don’t have an account?
            <Link to="/signup">
              <button> Sign Up</button>
            </Link>
          </h2>
        </div>

        <div className="signin-right-container">
          <img src={IMAGES.SIGNIN_MAIN} alt="signin image" />
        </div>
      </div>
    </div>
  );
};

export default SignIn_Page_1;
